import script from "./FavoriteVouchersPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./FavoriteVouchersPage.vue?vue&type=script&setup=true&lang=ts"

import "./FavoriteVouchersPage.vue?vue&type=style&index=0&id=da8c2e42&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-da8c2e42"]])

export default __exports__